export enum MessageType {
	assistant = 'assistant',
	user = 'user',
}
